import type { ReactNode } from 'react';

type Tone = 'info' | 'warning' | 'success' | 'error';

const toneClasses: Record<Tone, string> = {
  info: 'bg-brand-light text-brand-dark',
  warning: 'bg-amber-50 text-stale',
  success: 'bg-green-50 text-drop',
  error: 'bg-red-50 text-red-700',
};

/** Slim inline banner (offline / update / errors). */
export function Banner({
  tone = 'info',
  children,
  onDismiss,
}: {
  tone?: Tone;
  children: ReactNode;
  onDismiss?: () => void;
}): JSX.Element {
  return (
    <div
      role="status"
      className={`flex items-center justify-between gap-3 px-4 py-2 text-sm ${toneClasses[tone]}`}
    >
      <span>{children}</span>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded px-1 text-xs font-semibold opacity-70 hover:opacity-100"
          aria-label="Dismiss"
        >
          ✕
        </button>
      ) : null}
    </div>
  );
}
